export enum Cmdtypes {
  // 3분 간격 연결 확인용
  PING_PONG = 0,
  // 회원여부 확인
  MEMBER_CHECK = 2000,
  // 로그인
  LOGIN = 2001,
  // 로그아웃
  LOGOUT = 2031,
  // 이전 로그인 장치 로그아웃
  PREVIOUS_LOGOUT = 2002,
  // 홈 정보
  HOME_INFO = 2003,
  // 핀 번호 리셋
  PIN_RESET = 2004,
  // 위치정보 리스트
  LOCATION_INFO = 2020,
  // 장치 잠금 해제
  UNLOCK_DEVICE = 2030,
  // 휴대폰 연결상태
  CONNECT = 3000,
  // 장치 현재 위치
  CURRENT_LOCATION_INFO = 3001,
  // 배터리 정보
  BATTERY_INFO = 3002,
  // 권한 정보
  AUTH_INFO = 3003,
  // 위치 찾기 리스트 와이파이 목록
  WIFI_LIST = 3004,
  // 사이렌 시작
  // 앱에서 TTS가 재생된 후에도 3005 응답이 내려옴 : 앱에 대한 반응으로 참고
  SIREN_START = 3005,
  // 사이렌 중단
  SIREN_STOP = 3006,
  // 영상통화 시작
  CAMERA_START = 3007,
  // 영상통화 캠 전환
  CAMERA_CAM_ROTATE = 3008,
  // 영상통화 중지
  CAMERA_STOP = 3009,
  // 파일 리스트 정보
  EXPLORER_FILE_LIST = 3011,
  // 파일 내부 정보
  EXPLORER_FOLDER_INNER = 3012,
  // 파일 스토리지 정보
  EXPLORER_STORAGE_SIZE = 3013,
  // 파일 삭제
  EXPLORER_DATA_DELETE = 3014,
  // 비상 연락처 업데이트
  PHONE_NUMBER_UPDATE = 3015,
  // 잠금 메시지 업데이트
  LOCK_MSG_UPDATE = 3016,
  // 기기 잠금 상태
  LOCK_STATUS = 3017,
  // 위치 정보 업로드 확인
  LOCATION_INFO_CONFIRM,
  // 파일 리스트 다운로드 요청
  EXPLORER_FILE_DOWNLOAD_REQUEST = 3020,
  // 파일 리스트 다운로드 확인
  EXPLORER_FILE_DOWNLOAD_COMPLETE = 3021,
  // 파일 리스트 다운로드 취소
  EXPLORER_FILE_DOWNLOAD_CANCEL = 3022,
  DISCONNECTED_TO_OTHER_LOGIN = 9000,
}
